// Esta llamada es a una API de un controlador de Cifra, no de ninguna api pública
import axios from 'axios';

export const URL = '/api_publica/v1/guardias/disponibilidades';
// TODO: De momento es la misma url base pero le pondré /calendar o algo así
export const URL_DISPONIBILIDAD = URL;

// En datos debe de venir { disponibilidad: {...} }
export default {
  get(id, options) {
    return axios.get(`${URL}/${id}`, options);
  },
  save(datos, options) {
    return axios.post(`${URL}`, datos, options);
  },
  move(datos, options) {
    return axios.post(`${URL}/${datos.disponibilidad.id}/move`, datos, options);
  },
  destroy(id, tipoBorrado, options) {
    const data = { tipo_borrado: tipoBorrado };
    return axios.delete(`${URL}/${id}`, { data }, options);
  },
};
